import React from 'react';

import { ItemsProps } from './Items.props';

import ItemsView from './Items.view';

const ItemsContainer = (props: ItemsProps) => {
  return <ItemsView {...props} />;
};

export default ItemsContainer;
